function SideScroll(container) {
    this.container = container;
    this.buttons = this.container.querySelectorAll('.jsSideMenu button');
    this.triggerElements = Array.prototype.map.call(this.buttons, btn => this.container.querySelector('[data-id="' + btn.dataset.trigger + '"]'));

    inView.threshold(0.3);

    inView('.jsSideMenuInViewEl')
        .on('enter', el => {
            for (let i = 0; i < this.buttons.length; i++) this.buttons[i].classList.remove('active');
            this.container.querySelector('.jsSideMenu button[data-trigger="' + el.dataset.id + '"]').classList.add('active');
        })
    ;

    Array.prototype.forEach.call(this.buttons, el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            const trigger = el.dataset.trigger;
            const triggerEl = this.container.querySelector('[data-id="' + trigger + '"]');

            vanillaSmoothie.scrollTo(Math.ceil(triggerEl.offsetTop - (window.innerHeight / 100 * 15)), {
                duration: 800,
                easing: 'easeInOutQuad'
            })
        });
    });
};